import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function TermsModal({
  isOpen,
  onClose
}: TermsModalProps) {
  return <AnimatePresence data-id="element-195">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/60 backdrop-blur-sm" style={{
        zIndex: 50
      }} onClick={onClose} data-id="element-196" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="fixed inset-4 md:inset-x-auto md:inset-y-8 md:left-1/2 md:-translate-x-1/2 md:max-w-2xl md:w-full bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col" style={{
        zIndex: 51
      }} data-id="element-197">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-[#E8D5DC] bg-[#FFF5F0]" data-id="element-198">
              <h2 className="text-xl font-serif font-bold text-[#3D1F2E]" data-id="element-199">
                Términos y Condiciones
              </h2>
              <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-[#FDE8F0] transition-colors text-[#7A5C6B] hover:text-[#3D1F2E]" aria-label="Cerrar" data-id="element-200">
                <X className="w-5 h-5" data-id="element-201" />
              </button>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto px-6 py-6 text-[#3D1F2E] text-sm leading-relaxed space-y-6" data-id="element-202">
              <p className="text-[#7A5C6B] text-xs" data-id="element-203">
                Última actualización:{' '}
                {new Date().toLocaleDateString('es-MX', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
              </p>

              <section data-id="element-204">
                <h3 className="font-bold text-base mb-2 font-serif" data-id="element-205">
                  1. Información General
                </h3>
                <p data-id="element-206">
                  Al adquirir el producto digital{' '}
                  <strong data-id="element-207">"Anti‑Impulso"</strong> (en adelante, "el Producto"),
                  aceptas los presentes Términos y Condiciones en su totalidad.
                  El Producto es un ebook/guía digital en formato PDF diseñado
                  con fines educativos e informativos sobre hábitos de consumo.
                </p>
              </section>

              <section data-id="element-208">
                <h3 className="font-bold text-base mb-2 font-serif" data-id="element-209">
                  2. Naturaleza del Producto
                </h3>
                <p data-id="element-210">
                  Anti‑Impulso es un producto digital de carácter educativo e
                  informativo.{' '}
                  <strong data-id="element-211">
                    No constituye asesoría financiera, psicológica ni médica
                    profesional.
                  </strong>{' '}
                  Los resultados pueden variar según cada persona. Si
                  experimentas una crisis financiera o emocional severa, te
                  recomendamos buscar ayuda profesional calificada.
                </p>
              </section>

              <section data-id="element-212">
                <h3 className="font-bold text-base mb-2 font-serif" data-id="element-213">
                  3. Precio y Forma de Pago
                </h3>
                <p data-id="element-214">
                  El precio del Producto es de{' '}
                  <strong data-id="element-215">$129 MXN (pesos mexicanos)</strong>, equivalente a
                  aproximadamente $6.39 USD. El pago se realiza como pago único
                  a través de la plataforma Hotmart. Una vez completado el pago,
                  recibirás acceso inmediato y de por vida al contenido digital.
                </p>
              </section>

              <section data-id="element-216">
                <h3 className="font-bold text-base mb-2 font-serif" data-id="element-217">
                  4. Política de Reembolso
                </h3>
                <p data-id="element-218">
                  Ofrecemos una{' '}
                  <strong data-id="element-219">garantía de satisfacción de 30 días naturales</strong>{' '}
                  a partir de la fecha de compra. Si el Producto no cumple con
                  tus expectativas, puedes solicitar un reembolso completo
                  dentro de este período contactándonos directamente o a través
                  de la plataforma Hotmart. No se requiere justificación.
                </p>
              </section>

              <section data-id="element-220">
                <h3 className="font-bold text-base mb-2 font-serif" data-id="element-221">
                  5. Propiedad Intelectual
                </h3>
                <p data-id="element-222">
                  Todo el contenido del Producto, incluyendo textos, diseños,
                  gráficos, plantillas y materiales complementarios, está
                  protegido por las leyes de propiedad intelectual aplicables en
                  los Estados Unidos Mexicanos y tratados internacionales. Queda
                  estrictamente prohibida la reproducción, distribución,
                  modificación o reventa total o parcial del contenido sin
                  autorización expresa por escrito.
                </p>
              </section>

              <section data-id="element-223">
                <h3 className="font-bold text-base mb-2 font-serif" data-id="element-224">
                  6. Licencia de Uso
                </h3>
                <p data-id="element-225">
                  Al adquirir el Producto, obtienes una licencia personal,
                  intransferible y no exclusiva para uso individual. Esta
                  licencia te permite acceder, descargar e imprimir el contenido
                  para tu uso personal. No está permitido compartir,
                  redistribuir ni comercializar el Producto.
                </p>
              </section>

              <section data-id="element-226">
                <h3 className="font-bold text-base mb-2 font-serif" data-id="element-227">
                  7. Limitación de Responsabilidad
                </h3>
                <p data-id="element-228">
                  El Producto se proporciona "tal cual" con fines educativos. No
                  garantizamos resultados financieros específicos. En ningún
                  caso seremos responsables por daños directos, indirectos,
                  incidentales o consecuentes derivados del uso o la
                  imposibilidad de uso del Producto. Las cifras y estadísticas
                  mencionadas en el material de marketing son estimaciones con
                  fines ilustrativos.
                </p>
              </section>

              <section data-id="element-229">
                <h3 className="font-bold text-base mb-2 font-serif" data-id="element-230">
                  8. Protección de Datos Personales
                </h3>
                <p data-id="element-231">
                  Nos comprometemos a proteger tus datos personales conforme a
                  la{' '}
                  <strong data-id="element-232">
                    Ley Federal de Protección de Datos Personales en Posesión de
                    los Particulares (LFPDPPP)
                  </strong>{' '}
                  de México. Los datos recopilados durante la compra (nombre,
                  correo electrónico, información de pago) serán utilizados
                  exclusivamente para procesar tu pedido y enviarte el Producto.
                  No compartiremos tu información con terceros sin tu
                  consentimiento, salvo lo necesario para procesar el pago a
                  través de Hotmart.
                </p>
              </section>

              <section data-id="element-233">
                <h3 className="font-bold text-base mb-2 font-serif" data-id="element-234">
                  9. Derechos del Consumidor
                </h3>
                <p data-id="element-235">
                  Como consumidor en México, tus derechos están protegidos por
                  la <strong data-id="element-236">Ley Federal de Protección al Consumidor</strong> y
                  la{' '}
                  <strong data-id="element-237">Procuraduría Federal del Consumidor (PROFECO)</strong>
                  . Estos términos no limitan ni sustituyen los derechos que te
                  corresponden por ley. Para cualquier queja o reclamación,
                  puedes contactar a PROFECO al teléfono del consumidor: 55 5568
                  8722 o al 800 468 8722.
                </p>
              </section>

              <section data-id="element-238">
                <h3 className="font-bold text-base mb-2 font-serif" data-id="element-239">
                  10. Modificaciones
                </h3>
                <p data-id="element-240">
                  Nos reservamos el derecho de modificar estos Términos y
                  Condiciones en cualquier momento. Las modificaciones entrarán
                  en vigor a partir de su publicación en esta página. El uso
                  continuado del Producto después de dichas modificaciones
                  constituye tu aceptación de los nuevos términos.
                </p>
              </section>

              <section data-id="element-241">
                <h3 className="font-bold text-base mb-2 font-serif" data-id="element-242">
                  11. Legislación Aplicable
                </h3>
                <p data-id="element-243">
                  Estos Términos y Condiciones se rigen por las leyes vigentes
                  en los Estados Unidos Mexicanos. Para cualquier controversia
                  derivada de estos términos, las partes se someten a la
                  jurisdicción de los tribunales competentes de la Ciudad de
                  México, renunciando a cualquier otro fuero que pudiera
                  corresponderles.
                </p>
              </section>

              <section data-id="element-244">
                <h3 className="font-bold text-base mb-2 font-serif" data-id="element-245">
                  12. Contacto
                </h3>
                <p data-id="element-246">
                  Para cualquier duda, aclaración o solicitud relacionada con
                  estos Términos y Condiciones o con el Producto, puedes
                  contactarnos a través de la plataforma Hotmart o por correo
                  electrónico.
                </p>
              </section>

              <div className="border-t border-[#E8D5DC] pt-4 mt-4" data-id="element-247">
                <p className="text-[#7A5C6B] text-xs text-center" data-id="element-248">
                  Al realizar tu compra, confirmas que has leído, entendido y
                  aceptado estos Términos y Condiciones.
                </p>
              </div>
            </div>

            {/* Footer */}
            <div className="px-6 py-4 border-t border-[#E8D5DC] bg-[#FFF5F0]" data-id="element-249">
              <button onClick={onClose} className="w-full py-3 bg-[#C4467E] text-white rounded-full font-medium hover:bg-[#A33668] transition-colors" data-id="element-250">
                Entendido
              </button>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}